module.exports = __webpack_public_path__ + "static/media/veikals_paka_5.b1053da3.png";